<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"
*ngIf="isToggle"
>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>

<div class="select_all" *ngIf="gridView">
  <div class="detail_entered"  *ngFor="let landTitle of landTitles"
  (click)="onView(landTitle)">
    <div class="picture"></div>
    <div class="the_details">
      <h2 class="name">{{ landTitle.LandName }}</h2>
      <div class="other_detail">
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Acquisition Date: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{ landTitle.AcquisitionDate | date }}</span></p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Acquisition Cost:
          <span class="sub_element" style="font-weight: normal; margin-left: .5rem;" *ngIf="landTitle.TotalArea">{{
          getTotalCost(landTitle?.TotalCost)
            | currency:getCurrencyCode(landTitle.CurrencyId):'symbol-narrow'
        }}</span>

        <span class="sub_element" style="font-weight: normal; margin-left: .5rem;" *ngIf="!landTitle.TotalArea">0</span>
      </p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Area of land: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{ landTitle.TotalArea }}
          {{ getMeasureName(landTitle.MeasureId) }}</span></p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Address of Land: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{ landTitle?.AssetLocationAddress }}</span></p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Sub Sub Group Name: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{
          getSubSubGroupName(landTitle?.SubSubGroupId)
        }}</span></p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Expiration Date: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{ landTitle?.ExpirationDate | date }}</span></p>
        <p class="entry" style="color:black; margin-bottom:0; font-size: 1.3rem;">Status: <span class="sub_element" style="font-weight: normal; margin-left: .5rem;">{{ getAcquisitionTypeName(landTitle.AcquisitionTypeId) }}</span></p>
      </div>
    </div>
  </div>
</div>

<div class="card" *ngIf="listView">
  <table class="table table-hover" >
    <thead>
      <tr>
        <th scope="col">S/N</th>
        <th scope="col">Group Name</th>
        <th scope="col">Sub Group Name</th>
        <th scope="col">Sub Sub Group Name</th>
        <th scope="col">Land Code</th>
        <th scope="col">Land Title-Name</th>
        <th scope="col">Acquisition Date</th>
        <th scope="col">Area of land</th>
        <th scope="col">UOM</th>
        <th scope="col">Acquisition Cost</th>
        <th scope="col">Address of Land</th>
        <th scope="col">Expiration Date</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody >
      <tr *ngFor="let landTitle of landTitles; index as i"
      (click)="onView(landTitle)"
      style="cursor: pointer;"
      >
        <th scope="row">{{i + 1}}</th>
        <td>{{getGroupName(landTitle?.GroupId)}}</td>
        <td>{{getSubGroupName(landTitle?.SubGroupId)}}</td>
        <td>{{getSubSubGroupName(landTitle?.SubSubGroupId)}}</td>
        <td>{{ landTitle.LandCode }}</td>
        <td>{{ landTitle.LandName }}</td>
        <td>{{ landTitle.AcquisitionDate | date }}</td>
        <td>{{ landTitle.TotalArea }}</td>
          <td>{{ getMeasureName(landTitle.MeasureId) }}</td>
        <td>
          <span class="sub_element" *ngIf="landTitle.TotalArea">{{
            getTotalCost(landTitle?.TotalCost)
              | currency:getCurrencyCode(landTitle.CurrencyId):'symbol-narrow'
          }}</span>

          <span class="sub_element" *ngIf="!landTitle.TotalArea">0</span>
        </td>
        <td>{{ landTitle?.AssetLocationAddress }}</td>
        <td>{{ landTitle?.ExpirationDate | date }}</td>
        <td>{{ getAcquisitionTypeName(landTitle.AcquisitionTypeId) }}</td>
      </tr>

    </tbody>
  </table>

</div>

